import React, { FC } from 'react'

import { alpha, Box, useTheme } from '@mui/material'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { chartOptions } from '../chartOptions'
import { EmptyData } from '../EmptyData'
import { ReportWidgetsHeader } from '../ReportWidgetsHeader'
import { StyledWidgetWrapper } from '../StyledWidgetWrapper'
import { DurationItemType } from '../types'

import { getLocalizedDurationLabel } from './getLocalizedDurationLabel'

export const TransactionLenNumWidget: FC<{
  transactionsNumData: DurationItemType[] | undefined
  displayWidth: number
}> = ({ transactionsNumData, displayWidth }) => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()

  const chartData = {
    labels: transactionsNumData?.map((item) => getLocalizedDurationLabel(item.duration, t)),
    datasets: [
      {
        label: t('trades', 'Trades'),
        data: transactionsNumData?.map((item) => item.amount),
        backgroundColor: palette.blue[500],
        barThickness: 25,
        borderRadius: 2,
        hoverBackgroundColor: alpha(palette.blue[500] as string, 0.8),
      },
    ],
  }

  const isDataEmpty = transactionsNumData?.every(({ amount }) => Number(amount) === 0)

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader
        text={t(
          'transactionLengthNumberOfTransactions',
          'Transaction length: number of transactions',
        )}
        explanation={t(
          'theChartRepresentsHowManyTransactionsNumberBelongToEachCategory',
          'The chart represents how many transactions number-wise belong to each category',
        )}
      />

      {isDataEmpty ? (
        <Box mt={4}>
          <EmptyData />
        </Box>
      ) : (
        <Box ml={spacing(-3)}>
          <Bar
            data={chartData}
            options={chartOptions()}
            style={{ maxHeight: spacing(31) }}
            key={displayWidth}
          />
        </Box>
      )}
    </StyledWidgetWrapper>
  )
}
